export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";

export const RECEIVE_FETCH_TRASHBIN_SYNONYM_SUCCESS =
  "RECEIVE_FETCH_TRASHBIN_SYNONYM_SUCCESS";
